import { useAppDispatch } from './state'
import { acceptTerms as acceptTermsApi, getTerms as getTermsApi } from '../api/terms'
import { setTerms } from '../state/slices/terms_slice'
import he from 'he'

export const useTerms = () => {
  const dispatch = useAppDispatch()

  const acceptTerms = async (termsId: number) => {
    try {
      const result = await acceptTermsApi(termsId)

      if (result.data) {
        result.data.term.content = he.decode(result.data.term.content)

        dispatch(setTerms(result.data.term))
      }

      return true
    } catch (error) {
      return false
    }
  }

  const getTerms = async () => {
    try {
      const result = await getTermsApi()

      if (result.data) {
        result.data.term.content = he.decode(result.data.term.content)

        dispatch(setTerms(result.data.term))
      }

      return true
    } catch (error) {
      return false
    }
  }

  return {
    acceptTerms,
    getTerms
  }
}

export default useTerms
